import axios from 'axios';
import config from '../config';

const user = async ({ queryKey, ...other }) => {
  const res = await axios.get(`${config.API_URL}/api/accounts/profile/`);
  return res.data;
};

export default user;
